<p-dialog
        header="Edit"
        [modal]="true"
        [(visible)]="dialogController.dialogVisible"
        [draggable]="false"
        [resizable]="false"
        [style]="{ minWidth: '30vw' }"
        (onHide)="close()"
        [dismissableMask]="true">
    <div class="flex w-full align-items-center justify-content-between mb-2">
        <div class="flex mr-2">
            <label class="font-semibold">Typical Repair: </label>
        </div>
        <div class="flex">
            <p-dropdown
                    appendTo="body"
                    [options]="sjcs"
                    [(ngModel)]="selectedSjc"
                    optionLabel="display"
                    placeholder="Select custom typical repair"
                    [filter]="true"
                    filterBy="display"
                    [loading]="loading">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex align-items-center gap-2">
                        <div>{{ selectedOption.display }}</div>
                    </div>
                </ng-template>
                <ng-template let-selectedItem pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <div>{{ selectedItem.display }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" severity="secondary"
                  (click)="close()"/>
        <p-button
                label="Save"
                [loading]="loading"
                [disabled]="!selectedSjc"
                (onClick)="save()"/>
    </div>
</p-dialog>